// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2Dqyp","author":"Table_author__3jqs6","authorImage":"Table_authorImage__2B3Dt","unreadRow":"Table_unreadRow__3hcT1"};